import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { JacketView } from '@bibliocommons/deprecated-base-icons';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import cn from 'classnames';
import { VIEW } from 'app/constants/SearchConstants';

const JacketViewButton = ({ currentView, toggleListView, className }) => {
  const isActive = currentView === VIEW.MEDIUM ? 'active' : '';
  const toggleView = () => toggleListView(VIEW.MEDIUM);

  const btnClasses = cn(className, { active: currentView === VIEW.MEDIUM });

  return (
    <FormattedMessage id="jacket_view" values={{ isActive: isActive ? 'yes' : 'no' }}>
      {message => (
        <DefaultButton
          data-test-id="jacket-view-button"
          flat
          className={btnClasses}
          handleClick={toggleView}
          title={message}
        >
          <JacketView />
          <ScreenReaderMessage>{message}</ScreenReaderMessage>
        </DefaultButton>
      )}
    </FormattedMessage>
  );
};

JacketViewButton.propTypes = {
  className: PropTypes.string,
  currentView: PropTypes.oneOf(Object.values(VIEW)).isRequired,
  toggleListView: PropTypes.func.isRequired
};

export default JacketViewButton;
